import React from "react";

const CandidateLogsSkeleton = () => {
  return (
    <div>
      <div className="flex flex-col w-full h-full gap-3">
        <div className="flex justify-between">
          <div className="w-32 h-8 rounded-lg skeleton-bg"></div>
          <div className="w-6 h-6 rounded-full skeleton-bg"></div>
        </div>
        {new Array(10).fill(1).map((item, idx) => {
          return (
            <div key={idx} className="w-full h-6 rounded-lg skeleton-bg"></div>
          );
        })}
      </div>
    </div>
  );
};

export default CandidateLogsSkeleton;
